import { useEffect, useRef } from 'react'

const ignoreKeypressElements = ['TEXTAREA', 'INPUT']

interface KeypressHanlderProps {
  key: string
  target: EventTarget | null
}

const isIgnoreElement = (target: KeypressHanlderProps['target']) =>
  target instanceof HTMLElement &&
  ignoreKeypressElements.includes(target.nodeName)

const useKeyPress = (keysParam: string, onPress: (keyName: string) => void) => {
  const keys = keysParam.split(' ').map((key) => key.toLowerCase())
  const isSingleKey = keys.length === 1
  const pressedKeys: any = useRef([])

  const keyIsRequested = (key: string) => {
    key = key.toLowerCase()
    return keys.includes(key)
  }

  const addPressedKey = (key: string) => {
    key = key.toLowerCase()
    const update = pressedKeys.current.slice()
    update.push(key)
    pressedKeys.current = update
  }

  const removePressedKey = (key: string) => {
    key = key.toLowerCase()
    let update = pressedKeys.current.slice()
    const index = update.findIndex((sKey: string) => sKey === key)
    update = update.slice(0, index)
    pressedKeys.current = update
  }

  const downHandler = ({ key, target }: KeypressHanlderProps) => {
    if (isIgnoreElement(target)) {
      return
    }
    const isKeyRequested = keyIsRequested(key)
    if (isKeyRequested) {
      addPressedKey(key)
    }
  }

  const upHandler = ({ key, target }: KeypressHanlderProps) => {
    if (isIgnoreElement(target)) {
      return
    }
    const isKeyRequested = keyIsRequested(key)
    if (isKeyRequested) {
      if (isSingleKey) {
        pressedKeys.current = []
        onPress(key)
      } else {
        const containsAll = keys.every((i) => pressedKeys.current.includes(i))
        removePressedKey(key)
        if (containsAll) {
          onPress(key)
        }
      }
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)
    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [])
}

export default useKeyPress
